<template>
    <div id="childDisplayLocation">
        <v-card flat class="pf-width-100p">
          <v-card-text class="px-4">
            <h5 class="mt-1 mb-2 pf-font-22">DISPLAY LOCATIONS</h5>
            <h3 class="mt-3 pf-font-18">Placement</h3>
            <v-layout>
              <v-select style="max-width: 40%;" v-model="selectedStates" item-value="id" item-text="name" label="Select the States" :items="filteredStates" multiple small-chips deletable-chips></v-select>
            </v-layout>
            <v-data-table style="margin-top: 5%;" :headers="displayLocationHeaders" :items="displayLocations" class="pf-data-table">
              <template v-slot:items="props">
              <!-- <td></td>
              <td></td>
              <td></td> -->
              <td>
                  <v-select
                  v-model="props.item.status"
                  :items="displayLocations"
                  height="30px"
                  @change="statusChange"
                  ></v-select>
              </td>
              </template>
          
            </v-data-table>
            
          </v-card-text>
        </v-card>
    </div>
</template>
<script>
/* global session store config */
/* eslint complexity: ["error", 22] */
import swal from 'sweetalert2';
import { create, getOne, getCollection, update, remove, validateUrl, checkIfNoPFUrl } from '../../helpers/helpers';

export default {
  directives: {},
  components: {
  },
  data: vm => ({
    disabilityTypes: ['None', 'Mild', 'Moderate', 'Severe'],
    rules: {
      required: value => !!value || 'Field is required.',
      blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      websiteRules: [
        (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
        v => !v || checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      ]
    },
    displayLocationHeaders: [
      { text: 'Organization Name', value: 'organizationName', width: '20%', class: 'header-style' },
      { text: 'State', value: 'state', width: '20%', class: 'header-style' },
      { text: 'Website URL', value: 'websiteUrl', width: '20%', class: 'header-style' },
      { text: 'Status', value: 'status', width: '20%', class: 'header-style' }
    ],
    selectedDisplayLocation: 'anyWhere',
    selectedStates: [],
    agencyAddress: {
      line_1: '',
      line_2: '',
      city: '',
      country: '',
      state: '',
      zip: '',
      email: '',
      phone: '',
      website: '',
    },
    displayLocations: []
  }),
  computed: {
    filteredStates () {
      let countryId = this.agencyAddress.country ? this.agencyAddress.country : null;
      let options = this.State;
      return countryId ? options.filter(o => o.country.id === countryId) : options;
    },
    states () {
      return this.State.filter(o => o.country.id === '5f0af2eb1b61360afbb1aa0c');
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    }, 
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
  },
  async created () {
    this.initializeCountry();
    this.initializeState();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async initializeCountry () {
      if (!this.Country.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
          }
        }
      }
    },
  }
};
</script>

<style>
.header-style {
  background: #F195BF;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/pages/Children/displayLocations.vue